import f from "../../../funcs";
import Events from "../../Events";
import RowsStorage from "../RowsStorage";


// TODO: удалить этот плагин, когда появится нормальный кэш
/**
     * Леша:
     * Нужно за сегодня придумать как сделать чтобы при проставлении ролей в контрагенте он выпадал в писках без обновления браузера
     */
// Название говорит само за себя, решаем задач в лоб

let LIST_COMPANY = RowsStorage.get("LIST_COMPANY");
let LIST_TYPE_ROLE = RowsStorage.get("LIST_TYPE_ROLE");

let StupidFixCompanyRoles = Events.extend("StupidFixCompanyRoles", {
    init(LIST_TYPE_ROLE_COMPANY) {
        let create = LIST_TYPE_ROLE_COMPANY.create;

        LIST_TYPE_ROLE_COMPANY.create = function(data, callback) {
            if ( f.isFunction(data) ) {
                callback = data;
                data = {};
            }
            if ( !f.isFunction(callback) ) {
                callback = function() {};
            }

            if ( !data.ID_LIST_COMPANY || !data.ID_LIST_TYPE_ROLE ) {// never
                return create.call(LIST_TYPE_ROLE_COMPANY, data, callback);
            }

            LIST_COMPANY.get(data.ID_LIST_COMPANY, function(err, companyModel) {
                if ( !companyModel ) {
                    companyModel = LIST_COMPANY.collection.get(data.ID_LIST_COMPANY);
                }

                if ( err || !companyModel ) {
                    return create.call(LIST_TYPE_ROLE_COMPANY, data, callback);
                }

                let newRoleId = data.ID_LIST_TYPE_ROLE + "";
                let changes = {};
                let index;

                // ROLE
                let companyRoles = (companyModel.get("ROLE") || []).map(function(roleId) {
                    return roleId + "";
                });
                index = companyRoles.indexOf(newRoleId);
                if ( index == -1 ) {
                    companyRoles.push(newRoleId);
                    changes.ROLE = companyRoles;
                    changes.ROLE_RIGHTS = companyRoles;
                    changes.ROLES_COUNT = companyRoles.length + "";

                    // обновялем имена ролей
                    changes.ROLES_NAMES = companyRoles.map(function(roleId) {
                        return LIST_TYPE_ROLE.collection.get(roleId);
                    }).filter(function(roleModel) {
                        return !!roleModel;
                    }).map(function(roleModel) {
                        return roleModel.get("LIST_TYPE_ROLE_NAME");
                    }).join(", ");
                }

                if ( !Object.keys(changes).length ) {
                    return create.call(LIST_TYPE_ROLE_COMPANY, data, callback);
                }

                companyModel.set(changes, { update: false });
                LIST_COMPANY.sendEvent("__customRefreshInclude", companyModel);
                return create.call(LIST_TYPE_ROLE_COMPANY, data, callback);
            });
        };

        LIST_TYPE_ROLE_COMPANY.create_with = function() {
            let args = [].slice.call(arguments);
            return function() {
                let args2 = [].slice.call(arguments);
                return LIST_TYPE_ROLE_COMPANY.create.apply(LIST_TYPE_ROLE_COMPANY, args.concat(args2));
            };
        };


        let fixOnRemove = function(originalMethod, ids, callback) {
            if ( !f.isFunction(callback) ) {
                callback = function() {};
            }

            let companyTypeRoleModels = LIST_TYPE_ROLE_COMPANY.collection.getModels(ids);
            let companyIds = companyTypeRoleModels
                .map(function(model) {
                    return model.get("ID_LIST_COMPANY");
                })
                .filter(function(companyId) {
                    return companyId;
                });

            if ( !companyIds ) {
                return originalMethod.call(LIST_TYPE_ROLE_COMPANY, ids, callback);
            }

            let companyModels = LIST_COMPANY.collection.getModels(companyIds);
            companyModels.forEach(function(companyModel) {
                let removeRoles = companyTypeRoleModels.filter(function(companyTypeRoleModel) {
                    return companyTypeRoleModel.get("ID_LIST_COMPANY") == companyModel.id;
                });

                removeRoles.forEach(function(removeRoleId) {
                    removeRoleId = removeRoleId.get("ID_LIST_TYPE_ROLE") + "";

                    let changes = {};
                    let index;

                    // ROLE
                    let companyRoles = (companyModel.get("ROLE") || []).map(function(roleId) {
                        return roleId + "";
                    });
                    index = companyRoles.indexOf(removeRoleId);
                    if ( index != -1 ) {
                        companyRoles.splice(index, 1);
                        changes.ROLE = companyRoles;
                        changes.ROLE_RIGHTS = companyRoles;
                        changes.ROLES_COUNT = companyRoles.length + "";

                        // обновялем имена ролей
                        changes.ROLES_NAMES = companyRoles.map(function(roleId) {
                            return LIST_TYPE_ROLE.collection.get(roleId);
                        }).filter(function(roleModel) {
                            return !!roleModel;
                        }).map(function(roleModel) {
                            return roleModel.get("LIST_TYPE_ROLE_NAME");
                        }).join(", ");
                    }

                    if ( Object.keys(changes).length ) {
                        companyModel.set(changes, { update: false });
                        LIST_COMPANY.sendEvent("__customRefreshExclude", [companyModel]);
                    }
                });
            });

            return originalMethod.call(LIST_TYPE_ROLE_COMPANY, ids, callback);
        };

        let trash = LIST_TYPE_ROLE_COMPANY.trash;
        LIST_TYPE_ROLE_COMPANY.trash = fixOnRemove.bind(null, trash);
        let remove = LIST_TYPE_ROLE_COMPANY.remove;
        LIST_TYPE_ROLE_COMPANY.remove = fixOnRemove.bind(null, remove);

        LIST_TYPE_ROLE_COMPANY.trash_with = function() {
            let args = [].slice.call(arguments);
            return function() {
                let args2 = [].slice.call(arguments);
                return LIST_TYPE_ROLE_COMPANY.trash.apply(LIST_TYPE_ROLE_COMPANY, args.concat(args2));
            };
        };
    }
});

export default StupidFixCompanyRoles;
